import { Warehouse } from "lucide-react";
import { canAccess, roleAccess, type AccessVerb } from "@hisense/shared";
import { useAuth } from "@/app/auth";
import { SettledRules } from "@/components/ui/SettledRules";

/**
 * Năm quy tắc của Kho & LOT — chốt 20/09/2026 theo chuẩn (W-R01…W-R09: nhận theo đơn mua, số lô, chờ kiểm, sửa sai và tồn đầu kỳ, ai
 * được làm gì), khách bác lại được. Trước đây là bảy thẻ vàng "chờ khách xác nhận" rải trên hai trang và một tab rà quy tắc; nay là một
 * mục gập trung tính.
 */
export const WAREHOUSE_RULES_SETTLED = ["intake", "lot", "quarantine", "correction", "authority"] as const;

export function WarehouseRules() {
  return <SettledRules ns="warehouse" rules={WAREHOUSE_RULES_SETTLED} icon={Warehouse} />;
}

/** Cùng bộ giải quyền với máy chủ (ô tick menu Kho & LOT) — trước 20/09/2026 hai trang này chặn theo vai trò admin / quản lý. */
export function useWarehouseAccess() {
  const { user } = useAuth();
  const access = user ? user.access ?? roleAccess(user.role) : null;
  return (verb: AccessVerb, menu = "warehouse") => !!access && canAccess(access, menu, verb);
}
